import type { SocialOpportunityItem } from '@inference.engine/widgets/web';
import { create } from 'zustand';
import type {
  SocialMediaOpportunitiesState,
  SocialMediaOpportunitiesStore,
} from './social-media-opportunities-widget.store.types';

const initialState: SocialMediaOpportunitiesState = {
  detailsView: false,
  selectedItem: null,
  persistedSelectionTitle: null,
};

export const useSocialMediaOpportunitiesStore = create<SocialMediaOpportunitiesStore>((set) => ({
  ...initialState,

  setDetailsView: (value: boolean) => set({ detailsView: value }),

  setSelectedItem: (item: SocialOpportunityItem | null) =>
    set({
      selectedItem: item,
      // Persist the title for cross-remount restoration
      persistedSelectionTitle: item?.opportunityTitle ?? null,
    }),

  reset: () => set(initialState),

  clearPersistedSelection: () =>
    set({
      selectedItem: null,
      detailsView: false,
      persistedSelectionTitle: null,
    }),
}));
